define('ordersDetailTrackingListRowToolsView',[
  'app',
  'module',
  'settings',
  'underscore', 
  'ordersMailsUtils',
  'emailView',
  'modalsConfirmationView',
  'modalsAlertView',
  'tableFieldView',
  'ordersDetailTrackingEditView',
  'template!ordersDetailTrackingListRowToolsView',
  'entities/customers/customers',
  'entities/caccounts/htmltemplates'
], function (
  App,
  Module,  
  Settings,
  _,
  OrdersMailsUtils,
  EmailView,
  ConfirmationView,
  AlertView,
  FieldView,
  EditView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'orders-detail-tracking-list-row-tools-view ' + FieldView.prototype.className,

    ui: {
      prevewButton: '.preview',
      previewCarrierButton: '.previewCarrier',
      editButton: '.edit',
      deliveredButton: '.delivered', 
      mailButton: '.mail',      
      deleteButton: '.delete'
    },

    events: {
      'click @ui.prevewButton': 'onPreview',
      'click @ui.previewCarrierButton': 'onPreviewCarrier',
      'click @ui.deliveredButton': 'onDelivered',
      'click @ui.mailButton': 'onSendMail',
      'click @ui.editButton': 'onEdit',
      'click @ui.deleteButton': 'onDelete'
    },

    modelEvents: {
      'change:trackingStatus': 'renderDelivered'
    },

    onRender: function() {
      this.renderDelivered();

      if(!this.model.trackingUrl())
        this.ui.prevewButton.addClass('disabled');
    },

    serializeData: function () {
      var data = {};

      if (Settings.configValue('order.trackingPageUrl') && this.model.get('trackingUrl')) {
        data.showCarrierPreview = true;
      } else {
        data.showCarrierPreview = false;
      }

      return data;
    },

    renderDelivered: function() {
      if(this.model.get('trackingStatus') === 'delivered')
        this.ui.deliveredButton.addClass('disabled');
      else
        this.ui.deliveredButton.removeClass('disabled');
    },

    onPreview: function () {
      this.customer = App.request('customers:entity:end-user-id', this.tableView.model.get('order').get('endUserId'));
      this.customer.fetch().done(_.bind(function() {
        if(this.model.trackingUrl(this.customer))
          window.open(this.model.trackingUrl(this.customer), '_blank');
      }, this));
    },

    onPreviewCarrier: function () {
      window.open(this.model.get('trackingUrl'), '_blank');
    },

    onDelete: function () {
      ConfirmationView.prototype.open({
        text: _.i18n('orders.tracking.delete.confirmation'),
        onConfirm: _.bind(function() {
          this.model.remove().done(_.bind(function() {
            this.tableView.bodyView.deleteRow(this.options.rowView);
            this.tableView.model.get('order').fetch();
          }, this));
        },this)
      });
    },

    onEdit: function() {
      EditView.prototype.open(this.model, this.tableView.model.get('order'));
    },

    onDelivered: function () {
      if(this.model.get('trackingStatus') === 'delivered')
        return;

      var model = this.model.clone();
      model.set('trackingStatus', 'delivered', {silent: true});
      model.set('deliveryDate', new Date(), {silent: true});
      model.unset('refCommandLine', { silent: true });
      this.tableView.model.get('order').saveTracking(model).done(_.bind(function(data) {
        this.model.set(data);
        this.tableView.model.get('order').fetch();
      }, this));
    },

    onSendMail: function () {
      var order = this.tableView.model.get('order');
      order.set('trackings', [this.model.toJSON()]); 
    
      var configTemplate = null;
      _.each(Settings.configValue('mails.templates'), function (s) {
        if (s.template === 'MAIL_ORDER_TRACKING')
          configTemplate = s;
      }, this);

      if (configTemplate)        
        OrdersMailsUtils.sendMail([order], configTemplate, _.bind(function (mails) {
          this.model.set('sentDate', new Date());
          this.model.set('sentEmail', mails);
          this.model.unset('refCommandLine');
        }, this));      
    }
  });
});
